import { ElementWithImageModel } from "common/interfaces";

export function findElementsWithImages(model: Object) {
    const imagesToGenerate: ElementWithImageModel[] = [];
    const findAssetsToGenerate = obj => {
        for (const [key, value] of Object.entries(obj)) {
            if (key === "__generateImage") {
                imagesToGenerate.push(obj as ElementWithImageModel);
            }
            if (value && typeof value === "object") {
                findAssetsToGenerate(value);
            }
        }
    };
    findAssetsToGenerate(model);
    return imagesToGenerate;
}
